<template>
    <div class="grid-3 margem">
        <div>
            <label>Gerente do Projeto</label>
            <input type="text" readonly :value="projeto?.gerente?.name">
        </div>
        <div>
            <label>Assessor do Gerente</label>
            <select v-model="projeto.assessor_id" :disabled="somenteLeitura || (!isGerente(this.idUsuario) && !isAuditor)"
                @change="atualizarProjeto('assessor_id', projeto.assessor_id)">
                <option :value="null">-</option>
                <option v-for="u in usuarios" :key="u.id" :value="u.id">{{ u.nomeCompleto }}</option>
            </select>
        </div>
        <!-- <div>
            <label>Product Owner</label>
            <select v-model="projeto.product_owner_id"
                @change="atualizarProjeto('product_owner_id', projeto.product_owner_id)"
                :disabled="!isGerente(this.idUsuario)">
                <option :value="null">-</option>
                <option v-for="u in usuarios" :key="u.id" :value="u.id">{{ u.nomeCompleto }}</option>
            </select>
        </div> -->
    </div>
    <div>
        <h3>Pessoas com acesso ao projeto</h3>
        <ul class="lista">
            <li v-for="p, index in reordenarArray(projeto.permissoes)" :key="index" class="alinha-v"
                :class="{ 'automatico': p.automatico == 1 }"
                :title="p.automatico == 1 ? 'Uma tarefa foi atribuída a este usuário e ele foi adicionado ao projeto automaticamente.' : ''">
                <div>
                    <h3>
                        {{ p.nome }} {{ p.usuario_id == this.idUsuario ? '(Você)' : '' }}
                    </h3>
                    <div class="funções">
                        <span v-if="isGerente(p.usuario_id)">- Gerente do Projeto;</span>
                        <span v-if="p.usuario_id == projeto.assessor_id">- Assessor do Gerente</span>
                        <span v-if="p.usuario_id == projeto.product_owner_id">- Product Owner</span>
                        <template v-if="getEntregas(p.usuario_id).length > 0">
                            <span>Coordena os pacotes de trabalho:</span>
                            <span v-for="f, index in getEntregas(p.usuario_id)" :key="index">
                                {{ f }}<span v-if="index < getEntregas(p.usuario_id).length - 1">; </span>
                            </span>
                        </template>
                    </div>
                </div>
                <i v-if="!somenteLeitura && podeExcluir(p) && isGerente(this.idUsuario)" @click="removerUsuario(p.usuario_id)"
                    class="bi-dash-circle"></i>
            </li>
        </ul>
        <AutoCompleteComponent v-if="!somenteLeitura" :BaseOpcoes="usuarios" @adicionar="adicinarUsuario" />
        <div class="aviso bg-alerta alinha-v">
            <i class="bi-exclamation-triangle"></i>
            <span>
                Administradores e auditores também possuem acesso ao projeto!
            </span>
        </div>
    </div>
</template>

<script>
import { consultarSetores } from '@/services/usuario-setor'
import { sso } from "roboflex-thalamus-sso-lib";
import AutoCompleteComponent from '../AutoComplete/AutoCompleteComponent.vue';
import serviceProjetos from '@/services/serviceProjetos';

export default {
    name: 'GestãoDeAcessoComponent',
    components: {
        AutoCompleteComponent,
    },
    props: {
        propProjeto: {
            required: true
        },
        isAuditor: {
            type: Boolean,
            default: false,
        },
        somenteLeitura: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            projeto: this.propProjeto,
            usuarios: [],
            idUsuario: null,
            entregas: []
        }
    },
    created() {
        const usuarioLogado = sso.getUsuarioLogado()
        this.idUsuario = usuarioLogado.id
    },
    async mounted() {
        this.usuarios = (await consultarSetores()).usuarios;
        var response = await serviceProjetos.getEntregas(this.propProjeto.id);
        this.entregas = response?.projetos?.[0]?.entregas ?? [];
    },
    methods: {
        async atualizarProjeto(itemEditado, valor) {
            var payload = {
                [itemEditado]: valor
            }
            serviceProjetos.atualizarProjeto(this.projeto.id, payload);
            this.projeto = await serviceProjetos.getProjetoById(this.projeto.id)
        },
        getEntregas(id) {
            const entregas = [];
            // if (this.projeto.gerente_id == id) {
            //     funções.push('- Gerente do Projeto')
            // }
            this.entregas.forEach(entrega => {
                if (entrega.coordenador_id == id) {
                    entregas.push(`- ${entrega.nome}`);
                }
            });
            return entregas;
        },

        isGerente(id) {
            return parseInt(this.projeto.gerente_id) == parseInt(id)
        },

        adicinarUsuario(usuario) {
            var user = {
                usuario_id: usuario.id,
                nivel: 1,
                nome: usuario.nomeCompleto,
            }
            this.projeto.permissoes.push(user);
            this.atualizarPermissão(this.projeto.permissoes)
        },
        removerUsuario(id) {
            this.projeto.permissoes = this.projeto.permissoes.filter(i => i.usuario_id != id);
            this.atualizarPermissão(this.projeto.permissoes)
        },
        reordenarArray(array) {
            if (!Array.isArray(array)) return [];
            return array.slice().sort((a, b) => {
                if (a.usuario_id === this.projeto.gerente_id) return -1;
                if (b.usuario_id === this.projeto.gerente_id) return 1;
                if (a.usuario_id === this.idUsuario) return -1;
                if (b.usuario_id === this.idUsuario) return 1;
                return 0;
            });
        },
        podeExcluir(p) {
            if (parseInt(p.usuario_id) == parseInt(this.idUsuario) || parseInt(p.usuario_id) == parseInt(this.projeto.gerente_id) || p.automatico == 1 || parseInt(p.usuario_id) == parseInt(this.projeto.assessor_id)) {
                return false
            } else {
                return true
            }
        },
        atualizarPermissão(usuarios) {
            serviceProjetos.atualizarPermissão(this.projeto.id, usuarios);
        },
    },
}
</script>

<style scoped>
select:disabled {
    opacity: 1;
    border-color: var(--cor-cinza);
    cursor: not-allowed;
}

.lista {
    text-align: left;
    list-style: none;
}

.aviso {
    margin: 1rem;
    width: fit-content;
    padding: .5rem;
    border-radius: 12px;
    gap: .5rem;

    i {
        font-size: 20px;
    }
}

.lista {
    list-style: none;
    display: flex;
    gap: 5px;
    flex-wrap: wrap;

    li {
        border: 1px solid var(--cor-separador);
        padding: .5rem 1rem;
        border-radius: 6px;
        max-width: 14rem;

        .funções {
            display: flex;
            flex-flow: column;
            gap: 3px;
            margin-top: 5px;
        }

        i {
            font-size: 16px;
            color: var(--cor-erro);
            margin-left: .5rem;
            visibility: hidden;
            cursor: pointer;
        }
    }

    li:hover {
        i {
            visibility: visible;
        }
    }
}


.automatico {
    border-color: var(--cor-primaria) !important;
    background-color: var(--cor-primaria-fraca);
}
</style>